import { useMutation } from '@apollo/client';
import { Mutations } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const useUpdateBank = () => {
  const context = useAuthContext('payroll_employee:edit');
  const [updateAccountItem] = useMutation(Mutations.updateAccountItem, {
    context,
  });

  const mutation = (id, name) => {
    return updateAccountItem({ variables: { input: { id, name } } }).then(
      response => response.data.updateAccountItem,
    );
  };

  return mutation;
};

export default useUpdateBank;
